import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function HeroSection() {
  const {
    lang
  } = useLanguage();
  const trust = [{
    value: '100+',
    label: lang === 'es' ? 'Negocios construidos' : 'Businesses built'
  }, {
    value: '100%',
    label: lang === 'es' ? 'Estrategia a medida' : 'Tailored Strategy'
  }, {
    value: '<2 sem',
    valueEn: '<2 wks',
    label: lang === 'es' ? 'Entrega promedio' : 'Average Delivery'
  }];
  return <section id="inicio" className="relative bg-inkova-cream min-h-[100svh] flex flex-col justify-center overflow-hidden pt-24 pb-12 lg:pt-0 lg:pb-0" data-id="element-212">
      {/* Extremely subtle paper texture */}
      <div className="pointer-events-none absolute inset-0 z-0 mix-blend-multiply" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.02'/%3E%3C/svg%3E\")"
    }} data-id="element-213" />

      {/* Decorative background typography */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none select-none z-0 overflow-hidden w-full flex justify-center opacity-[0.015]" data-id="element-214">
        <span className="font-serif font-bold text-[20vw] leading-none text-inkova-dark whitespace-nowrap" data-id="element-215">
          INKOVA
        </span>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 w-full relative z-10 flex-1 flex flex-col justify-center" data-id="element-216">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-12 lg:gap-0 items-center h-full relative" data-id="element-217">
          {/* TEXT COLUMN */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1.2,
          ease: [0.16, 1, 0.3, 1],
          delay: 0.2
        }} className="flex flex-col justify-center order-2 lg:order-1 relative z-20" data-id="element-218">
            <div className="flex items-center gap-4 mb-10" data-id="element-219">
              <span className="block w-[60px] h-[1px] bg-inkova-primary/40" data-id="element-220" />
              <span className="text-[10px] font-sans font-medium tracking-[4px] uppercase text-inkova-primary" data-id="element-221">
                {lang === 'es' ? 'Miami · Agencia Digital' : 'Miami · Digital Agency'}
              </span>
            </div>

            <h1 className="font-serif font-semibold text-[56px] sm:text-[72px] lg:text-[clamp(80px,7.5vw,120px)] leading-[1.05] tracking-[-0.03em] text-inkova-dark mb-8" data-id="element-222">
              {lang === 'es' ? <>
                  <span className="block" data-id="element-223">Tu negocio digital,</span>
                  <span className="block" data-id="element-224">construido desde tu</span>
                  <span className="block italic text-inkova-lavender font-medium text-[1.15em] mt-1" data-id="element-225">
                    identidad y propósito.
                  </span>
                </> : <>
                  <span className="block" data-id="element-226">Your digital business,</span>
                  <span className="block" data-id="element-227">built from your</span>
                  <span className="block italic text-inkova-lavender font-medium text-[1.15em] mt-1" data-id="element-228">
                    identity and purpose.
                  </span>
                </>}
            </h1>

            <p className="text-[15px] lg:text-[16px] text-inkova-dark/55 font-light leading-[1.85] max-w-[460px] mb-12" data-id="element-229">
              {lang === 'es' ? 'Diseñamos negocios digitales con claridad, estrategia e intención. Tu presencia digital debe comunicar tu valor antes de que hables.' : 'We design digital businesses with clarity, strategy and intention. Your digital presence should communicate your value before you speak.'}
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-6 mb-16 lg:mb-24" data-id="element-230">
              <a href="https://calendly.com/inkovacreation" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center bg-gradient-to-br from-[#6B3FA0] to-[#8B5FC4] text-white px-10 py-5 rounded-[18px] font-sans font-medium text-[13px] tracking-[1px] uppercase overflow-hidden transition-all duration-500 shadow-[0_8px_24px_rgba(107,63,160,0.25)] hover:shadow-[0_12px_40px_rgba(107,63,160,0.4)] hover:scale-[1.02] w-full sm:w-auto" data-id="element-231">
                <span className="relative z-10" data-id="element-232">
                  {lang === 'es' ? 'Da el primer paso' : 'Take the first step'}
                </span>
              </a>
              <a href="https://wa.me/13054781618" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center border-[1.5px] border-inkova-dark/20 text-inkova-dark px-10 py-5 rounded-[18px] font-sans font-medium text-[13px] tracking-[1px] uppercase hover:border-inkova-primary/40 hover:bg-inkova-primary/5 transition-all duration-500 w-full sm:w-auto" data-id="element-233">
                {lang === 'es' ? 'Tengo una pregunta' : 'I have a question'}
              </a>
            </div>

            {/* Editorial Metrics with dividers */}
            <div className="flex flex-wrap items-center gap-8 lg:gap-12" data-id="element-234">
              {trust.map((item, index) => <Fragment key={index} data-id="element-235">
                  <div className="flex flex-col" data-id="element-236">
                    <div className="flex items-baseline gap-1.5 mb-2" data-id="element-237">
                      <span className="text-inkova-lavender/60 font-serif text-[16px] italic leading-none" data-id="element-238">
                        ↑
                      </span>
                      <strong className="font-serif font-normal text-[42px] lg:text-[52px] text-inkova-dark leading-none tracking-[-1.5px]" data-id="element-239">
                        {lang === 'en' && item.valueEn ? item.valueEn : item.value}
                      </strong>
                    </div>
                    <span className="text-[10px] text-inkova-dark/35 font-sans uppercase tracking-[2.5px]" data-id="element-240">
                      {item.label}
                    </span>
                  </div>
                  {index < trust.length - 1 && <div className="hidden sm:block w-[1px] h-[48px] bg-inkova-border" data-id="element-241" />}
                </Fragment>)}
            </div>
          </motion.div>

          {/* PHOTO COLUMN - Full bleed on desktop */}
          <motion.div initial={{
          opacity: 0,
          filter: 'blur(10px)'
        }} animate={{
          opacity: 1,
          filter: 'blur(0px)'
        }} transition={{
          duration: 1.5,
          ease: [0.16, 1, 0.3, 1]
        }} className="relative h-[60vh] lg:absolute lg:right-0 lg:top-0 lg:bottom-0 lg:w-[50vw] lg:h-full order-1 lg:order-2" data-id="element-242">
            <div className="absolute inset-0 rounded-[24px] lg:rounded-none overflow-hidden" data-id="element-243">
              <img src="https://cdn.magicpatterns.com/uploads/4hmVMs8fGXLBDG4G7Yo7Co/annysol-hero.jpg.png" alt="Annysol Navarro, fundadora de Inkova Creation" loading="eager" className="w-full h-full object-cover [object-position:center_20%] scale-105 animate-slow-zoom" data-id="element-244" />
              {/* Film grain overlay */}
              <div className="pointer-events-none absolute inset-0 mix-blend-overlay opacity-[0.025]" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='grain'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='1.2' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23grain)'/%3E%3C/svg%3E\")"
            }} data-id="element-245" />
              {/* Strong left-edge gradient fade to cream */}
              <div className="absolute inset-0 bg-gradient-to-r from-inkova-cream via-inkova-cream/60 to-transparent lg:from-inkova-cream lg:via-inkova-cream/40 lg:[mask-image:linear-gradient(to_right,black_0%,transparent_30%)]" data-id="element-246" />
              {/* Mobile gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-inkova-cream via-transparent to-transparent lg:hidden" data-id="element-247" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}